'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _QuantitativeFilters = require('./QuantitativeFilters.scss');var styles = _interopRequireWildcard(_QuantitativeFilters);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var QuantitativeFilters = function (_Component) {_inherits(QuantitativeFilters, _Component);function QuantitativeFilters() {var _temp, _this, _ret;_classCallCheck(this, QuantitativeFilters);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (evt, field, fieldValue) {
      var value = evt.currentTarget.value.replace(/[\D]/g, '');
      evt.currentTarget.value = value;var _this$props$fields =

      _this.props.fields,floor = _this$props$fields.floor,area = _this$props$fields.area,constructionYear = _this$props$fields.constructionYear;
      if (field === 'floor') {var _Object$assign;
        if (value > 99) {
          return;
        }
        if (fieldValue === 'min' && +floor.max > 0 && +floor.max < +value) {
          return;
        }
        _this.props.onChange('floor', Object.assign({}, floor, (_Object$assign = {}, _Object$assign[fieldValue] = value, _Object$assign)));
      }

      if (field === 'area') {var _Object$assign2;
        if (value > 9999) {
          return;
        }
        if (fieldValue === 'min' && +area.max > 0 && +area.max < +value) {
          return;
        }
        _this.props.onChange('area', Object.assign({}, area, (_Object$assign2 = {}, _Object$assign2[fieldValue] = value, _Object$assign2)));
      }

      if (field === 'constructionYear') {
        if (fieldValue === 'min' && +constructionYear.max > 0 && +constructionYear.max < +value) {
          return;
        }
        if (value.length >= 4 && (value < 1900 || value > 2027)) {var _Object$assign3;
          _this.props.onChange('constructionYear', Object.assign({}, constructionYear, (_Object$assign3 = {}, _Object$assign3[fieldValue] = null, _Object$assign3)));
        } else {var _Object$assign4;
          _this.props.onChange('constructionYear', Object.assign({}, constructionYear, (_Object$assign4 = {}, _Object$assign4[fieldValue] = value, _Object$assign4)));
        }
      }
    }, _this.

    formatPriceParameters = function (field) {return {
        value: (0, _beautifyNumber2.default)(_this.props.fields.price[field]),
        onChange: function onChange(value) {var _Object$assign5;return _this.props.onChange('price', Object.assign({},
          _this.props.fields.price, (_Object$assign5 = {}, _Object$assign5[
          field] = (0, _clearNumber2.default)(value), _Object$assign5)));} };}, _this.



    createParams = function (field, fieldValue) {
      var value = _this.props.fields[field][fieldValue];
      return {
        value: value || '',
        onChange: function onChange(evt) {return _this.handleChange(evt, field, fieldValue);} };

    }, _this.

    renderPrice = function () {return (
        _react2.default.createElement('div', { className: styles.priceField },
          _react2.default.createElement(_components.OMFiltersTitle, {
            icon: 'coin',
            label: _this.props.translate('search_box', 'searchContainer', 'price') }),

          _react2.default.createElement('div', { className: styles.priceWrapper },
            _react2.default.createElement(_components.MinMaxPrices, {
              inFilters: true,
              className: 'lineFiltersPrice',
              translate: _this.props.translate,
              minPrice: _this.formatPriceParameters('minPrice'),
              maxPrice: _this.formatPriceParameters('maxPrice'),
              minPlaceholder: '' + _this.props.translate('advancedFilters', 'minPlaceholder'),
              maxPlaceholder: '' + _this.props.translate('advancedFilters', 'maxPlaceholder'),
              separator: _this.props.translate('advancedFilters', 'until').toString() }),

            _react2.default.createElement('span', null, '\u20AA'))));}, _temp), _possibleConstructorReturn(_this, _ret);}QuantitativeFilters.prototype.



  render = function render() {var _this2 = this;
    var smallScreen = window && window.innerWidth < 1065;var
    notLastFloor = this.props.fields.notLastFloor;
    var filtersCheckboxesArray = ['parkingSpot', 'balcony', 'elevator'];var
    isMobile = this.props.isMobile;

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        filtersCheckboxesArray.map(function (field) {return (
            _react2.default.createElement(_components.OMAdvancedFiltersCheckbox, {
              key: field,
              name: field,
              label: '' + _this2.props.translate('advancedFilters', field),
              value: _this2.props.fields[field],
              isMobile: isMobile,
              onChange: _this2.props.onChange }));}),


        _react2.default.createElement('div', { className: styles.floorWrapper },
          _react2.default.createElement(_components.OMTwinInputRow, {
            field: {
              min: this.createParams('floor', 'min'),
              max: this.createParams('floor', 'max') },

            checkMaxValue: function checkMaxValue() {return _this2.props.handleCheckMaxValue('floor');},
            label: '' + this.props.translate('advancedFilters', 'floor'),
            icon: 'floor',
            minPlaceholder: '' + this.props.translate('advancedFilters', 'floor'),
            maxPlaceholder: '' + this.props.translate('advancedFilters', 'floor'),
            isMobile: isMobile,
            className: 'advancedFiltersTwin',
            separator: this.props.translate('advancedFilters', 'until').toString() }),

          _react2.default.createElement(_components.OMCheckbox, {
            field: {
              value: notLastFloor,
              checked: notLastFloor,
              onChange: function onChange() {return _this2.props.onChange('notLastFloor', !notLastFloor);} },

            label: '' + this.props.translate('advancedFilters', 'notLastFloor') })),


        smallScreen && !isMobile && this.renderPrice(),
        _react2.default.createElement('div', { className: styles.sizeWrapper },
          _react2.default.createElement(_components.OMTwinInputRow, {
            field: {
              min: this.createParams('area', 'min'),
              max: this.createParams('area', 'max') },

            checkMaxValue: function checkMaxValue() {return _this2.props.handleCheckMaxValue('area');},
            label: '' + this.props.translate('advancedFilters', 'size'),
            icon: 'square',
            minPlaceholder: '' + this.props.translate('advancedFilters', 'minPlaceholder'),
            maxPlaceholder: '' + this.props.translate('advancedFilters', 'maxPlaceholder'),
            isMobile: isMobile,
            className: 'advancedFiltersTwin',
            separator: this.props.translate('advancedFilters', 'until').toString() })),


        _react2.default.createElement('div', { className: styles.yearWrapper },
          _react2.default.createElement(_components.OMTwinInputRow, {
            field: {
              min: this.createParams('constructionYear', 'min'),
              max: this.createParams('constructionYear', 'max') },

            checkMaxValue: function checkMaxValue() {return _this2.props.handleCheckMaxValue('constructionYear');},
            label: '' + this.props.translate('advancedFilters', 'constructionYear'),
            icon: 'construction-year',
            minPlaceholder: '' + this.props.translate('advancedFilters', 'yearMinPlaceholder'),
            maxPlaceholder: '' + this.props.translate('advancedFilters', 'yearMaxPlaceholder'),
            isMobile: isMobile,
            className: 'advancedFiltersTwin',
            separator: this.props.translate('advancedFilters', 'until').toString() }))));





  };return QuantitativeFilters;}(_react.Component);


QuantitativeFilters.propTypes = {
  translate: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  handleCheckMaxValue: _propTypes2.default.func };exports.default =


QuantitativeFilters;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuantitativeFilters/QuantitativeFilters.js
// module id = 2849
// module chunks = 0